import { SnipingOpportunitiesCard } from './components/SnipingOpportunitiesCard';
import config from 'config';
import TelegramChannels from './components/TelegramChannels';
import { Wallets } from './components/Wallets';
import { TelegramCalls } from './components/TelegramCalls';
import { HotTokens } from './components/HotTokens';
import { SmartSwaps } from './components/SmartSwaps';
import PageTemplate from '../components/layout';
import {
  MAIN_INFO,
  RESEARCH_SIDEBAR,
  Tabs,
} from '../components/layout/SIDEBAR_CONST';
import { useParams } from 'react-router-dom';
import { useSelectedChain } from '../components/chains/getChains';

export default function Research() {
  const { tab: activeTab } = useParams<{ tab: Tabs }>();
  return (
    <PageTemplate
      sidebar={RESEARCH_SIDEBAR(useSelectedChain())}
      mainInfo={MAIN_INFO.research.filter(
        (info) => info.activeTab === activeTab
      )}
      className="lg:px-1"
      pages={[
        ...(config.isTelegramBrowser
          ? [
              {
                href: '/dex/navigation',
                name: 'Navigation',
              },
            ]
          : []),
        {
          href: '/dex/research',
          name: 'Research',
        },
      ]}
    >
      <div className="w-full xxs:space-y-0 lg:space-y-1">
        {activeTab === Tabs.Wallets && <Wallets />}
        {activeTab === Tabs.TelegramCalls && <TelegramCalls />}
        {activeTab === Tabs.NewPools && <SnipingOpportunitiesCard />}
        {activeTab === Tabs.TelegramChannels && <TelegramChannels />}
        {activeTab === Tabs.HotTokens && <HotTokens />}
        {activeTab === Tabs.SmartSwaps && <SmartSwaps />}
      </div>
    </PageTemplate>
  );
}
